import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['amountHtInput', 'vatInput', 'amountTtcInput'];
  static values = { vats: Object }

  updateMontantTtc() {
    const ht_value = this.amountHtInputTarget.value;
    const vat_id_value = this.vatInputTarget['form--collection-select--component'].value;
    const vat_value = this.vatsValue[vat_id_value];

    // Si la TVA est renseignée, on remplace le montant TTC
    if (typeof(vat_value) != 'undefined') {
      let ttc_value = parseFloat(ht_value) + parseFloat(vat_value);
      this.amountTtcInputTarget.value = ttc_value.toFixed(2);
      this.amountTtcInputTarget.dispatchEvent(new Event('change'));
    }
  }

  updateMontantHt() {
    const ttc_value = this.amountTtcInputTarget.value;
    const vat_id_value = this.vatInputTarget['form--collection-select--component'].value;
    const vat_value = this.vatsValue[vat_id_value];
    if (typeof(vat_value) != 'undefined') {
      let ht_value = parseFloat(ttc_value) / (1 + (parseFloat(vat_value) / 100));
      this.amountHtInputTarget.value = ht_value.toFixed(2);
    }
  }
}
